import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { canUseDOM } from '@surfline/web-common';
import { useUserDetailsSelector, useEntitlementsSelector } from '../../../selectors/user';
import { useMeterSelector } from '../../../selectors/metering';
import { useModalComputer } from './useModalComputer';

const RegWall = ({ renderOptions: { rateLimitingEnabled } }) => {
  const [ready, setReady] = useState(false);
  const entitlements = useEntitlementsSelector();
  const user = useUserDetailsSelector();
  const meter = useMeterSelector();
  const modalToRender = useModalComputer(meter, user, entitlements);

  useEffect(() => {
    if (canUseDOM && rateLimitingEnabled && meter) {
      setReady(true);
    }
  }, [rateLimitingEnabled, ready, meter, modalToRender]);

  // When the reg-wall mounts, we want to scroll the page to the top
  useEffect(() => {
    if (ready && modalToRender) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [ready, modalToRender]);

  return <div data-scroll-lock-scrollable>{ready && modalToRender ? modalToRender : null}</div>;
};

RegWall.propTypes = {
  renderOptions: PropTypes.shape({
    rateLimitingEnabled: PropTypes.oneOf(['true', 'false']),
  }),
};

RegWall.defaultProps = {
  renderOptions: PropTypes.shape({}),
};

export default RegWall;
